import { ExportModel, type NetworkExport, type PostExport, type PostExportResponse } from '@/models/export';
import type { ExportLink } from '@/models/exportLink';
import { signedApiClient } from '@/services/apiClient';

class ExportService {

  private investigationEndpoint: string = '';
  private exportEndpoint: string = '';

  inviteService(investigationEndpoint: string, exportEndpoint: string) {
    this.investigationEndpoint = investigationEndpoint;
    this.exportEndpoint = exportEndpoint;
  }

  async getStudyExports(id: string) {
    const uri = `${this.investigationEndpoint}/${id}/exports`;
    const apiClient = signedApiClient('GET', uri);
    const exportsResponse = await apiClient.get(uri);
    const exportList: NetworkExport[] = exportsResponse.data;
    return exportList.map(exportItem => ExportModel.mapFromBackend(exportItem));
  }

  async getExportSignedUrl(id: string) {
    const uri = `${this.exportEndpoint}/${id}`;
    const apiClient = signedApiClient('GET', uri);
    const exportsResponse = await apiClient.get(uri);
    const exportLink: ExportLink = exportsResponse.data;
    return exportLink;
  }

  async createStudyExport(id: string, postExport: PostExport) {
    const uri = `${this.investigationEndpoint}/${id}/exports`;
    const apiClient = signedApiClient('POST', uri);
    const exportsResponse = await apiClient.post(uri, postExport);
    const exportItem: PostExportResponse = exportsResponse.data;
    return exportItem;
  }

  async deleteExports(ids: string[]) {
    const uri = this.exportEndpoint;
    const apiClient = signedApiClient('DELETE', uri);
    await apiClient.delete(uri, {
      data: { ids }
    });
  }

  async retryExport(id: string) {
    const uri = `${this.exportEndpoint}/${id}/retry`;
    const apiClient = signedApiClient('POST', uri);
    await apiClient.post(uri);
  }
}

export default new ExportService();
